import { localStore } from '@/_utils/localstore'

interface GoogleApiConfig {
  geoCode: string
}

export class Config {
  public get apiUrl() {
    let apiUrl: string = ''
    const unit = this.unit

    switch (process.env.VUE_APP_API_BASE_URL) {
      case 'development':
        apiUrl = `http://${unit}.socan-api.local:4000`
        break

      case 'sango-test':
        apiUrl = `https://${unit}.sango-testing.in`
        break

      case 'socan-test':
        apiUrl = `https://${unit}.socan-testing.in`
        break

      case 'prod':
        apiUrl = `https://${unit}.socan-prod.in`
        break

      case 'prod-t1':
        apiUrl = `https://${unit}.socan-prod-t1.in`
        break

      case 'local-jbox':
        apiUrl = `http://${window.location.hostname}:4000`
        break

      default:
        console.log('Unknown VUE_APP_API_BASE_URL!')
        break
    }

    return apiUrl
  }

  public get unit(): string {
    return localStore.getItem('login_unit') as string
  }

  get googleApiKey(): GoogleApiConfig {
    return {
      geoCode: 'AIzaSyCDLEYFj5LxIB4RMpYF-U62ryPCAZ1jhVQ',
    }
  }

  public setUnit(unit: string): void {
    localStore.setItem('login_unit', unit)
  }
}

const config = new Config()
export default config
